import { useContext } from 'react';

import { UserContext } from './AuthUserContext';

export function useAccessToken() {
  const userInfo = useContext(UserContext);

  if (userInfo) {
    return userInfo.accessToken;
  }

  throw new Error('useAccessToken must be used inside UserContext Provider. User information not found.');
}
